module.exports = __webpack_public_path__ + "img/claimed-zh.d3afaf45.png";